import { Col, Space, Typography } from 'antd';
import styled from 'styled-components';

const Container = styled(Space)`
  background-color: #fff;
  border-radius: 0.5rem;
  padding: 16px;
  height: 100%;
`;

const Image = styled.img`
  width: 50px;
`;

interface ServiceSectionProps {
  icon: string;
  title: string;
  description: string;
}

export const ServiceSection = ({ icon, title, description }: ServiceSectionProps): JSX.Element => {
  return (
    <Col xs={24} sm={12}>
      <Container size="middle">
        <Image src={icon} />
        <Space direction="vertical" size="small">
          <Typography.Title level={5}>{title}</Typography.Title>
          <Typography.Text type="secondary">{description}</Typography.Text>
        </Space>
      </Container>
    </Col>
  );
};
